import React from 'react';
import Types from 'prop-types';
import FooterLink from './FooterLink';
var FooterLinks = function FooterLinks(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled"
  }, items.map(function (_ref2) {
    var icons = _ref2.icons,
      link = _ref2.link,
      translationKey = _ref2.translationKey;
    return /*#__PURE__*/React.createElement(FooterLink, {
      icons: icons,
      link: link,
      translationKey: translationKey,
      key: icons && icons.length ? icons[0].link : translationKey
    });
  }));
};
export default FooterLinks;